var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "d-flex justify-content-center" }, [
        _c("img", {
          attrs: {
            src:
              "https://beneat.s3.ap-southeast-1.amazonaws.com/images/irobot_survey.jpg",
            width: _vm.$mq.phone ? "350" : "500",
            alt: "..."
          }
        })
      ]),
      _vm._v(" "),
      _vm.isCompleted
        ? [_vm._m(0)]
        : [
            _c(
              "div",
              { staticClass: "text-center mt-4" },
              [_vm.$mq.phone ? [_vm._m(1)] : [_vm._m(2)]],
              2
            ),
            _vm._v(" "),
            _c("div", [
              _c(
                "form",
                {
                  attrs: { "data-vv-scope": "irobot" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.formSubmit()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.name,
                          expression: "form.name"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "form-control input-jumbo",
                      class: { "form-alert": _vm.errors.has("irobot.name") },
                      style: _vm.$mq.phone ? "" : "width:40%",
                      attrs: { type: "text", id: "name", name: "name" },
                      domProps: { value: _vm.form.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "name", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("irobot.name")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tel,
                          expression: "form.tel"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "form-control input-jumbo",
                      class: { "form-alert": _vm.errors.has("irobot.tel") },
                      style: _vm.$mq.phone ? "" : "width:40%",
                      attrs: { type: "number", id: "tel", name: "tel" },
                      domProps: { value: _vm.form.tel },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "tel", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("irobot.tel")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pl-2" }, [
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.workshop_date,
                                expression: "form.workshop_date"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "workshop_date",
                              id: "workshop_date_1",
                              value: "2024-10-19"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.form.workshop_date,
                                "2024-10-19"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "workshop_date",
                                  "2024-10-19"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(6)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.workshop_date,
                                expression: "form.workshop_date"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "workshop_date",
                              id: "workshop_date_2",
                              value: "2024-10-19"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.form.workshop_date,
                                "2024-10-19"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "workshop_date",
                                  "2024-10-19"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(7)
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("irobot.workshop_date")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pl-2" }, [
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.workshop_time,
                                expression: "form.workshop_time"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "workshop_time",
                              id: "workshop_time_1",
                              value: "10:30 - 12:00"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.form.workshop_time,
                                "10:30 - 12:00"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "workshop_time",
                                  "10:30 - 12:00"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(9)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.workshop_time,
                                expression: "form.workshop_time"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "workshop_time",
                              id: "workshop_time_2",
                              value: "14:00 - 15:30"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.form.workshop_time,
                                "14:00 - 15:30"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "workshop_time",
                                  "14:00 - 15:30"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(10)
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("irobot.workshop_time")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pl-2" }, [
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.number_of_paticipants,
                                expression: "form.number_of_paticipants"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "number_of_paticipants",
                              id: "number_of_paticipants_1",
                              value: "1"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.form.number_of_paticipants,
                                "1"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "number_of_paticipants",
                                  "1"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(12)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.number_of_paticipants,
                                expression: "form.number_of_paticipants"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "number_of_paticipants",
                              id: "number_of_paticipants_2",
                              value: "2"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.form.number_of_paticipants,
                                "2"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "number_of_paticipants",
                                  "2"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(13)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.number_of_paticipants,
                                expression: "form.number_of_paticipants"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "number_of_paticipants",
                              id: "number_of_paticipants_3",
                              value: "3"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.form.number_of_paticipants,
                                "3"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "number_of_paticipants",
                                  "3"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(14)
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("irobot.number_of_paticipants")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(15),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pl-2" }, [
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.irobot_usage_status,
                                expression: "form.irobot_usage_status"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "irobot_usage_status",
                              id: "irobot_usage_status_1",
                              value: "1"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.irobot_usage_status, "1")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "irobot_usage_status",
                                  "1"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(16)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.irobot_usage_status,
                                expression: "form.irobot_usage_status"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "irobot_usage_status",
                              id: "irobot_usage_status_2",
                              value: "2"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.irobot_usage_status, "2")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "irobot_usage_status",
                                  "2"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(17)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.irobot_usage_status,
                                expression: "form.irobot_usage_status"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "irobot_usage_status",
                              id: "irobot_usage_status_3",
                              value: "3"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.irobot_usage_status, "3")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "irobot_usage_status",
                                  "3"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(18)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.irobot_usage_status,
                                expression: "form.irobot_usage_status"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "irobot_usage_status",
                              id: "irobot_usage_status_4",
                              value: "4"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.irobot_usage_status, "4")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "irobot_usage_status",
                                  "4"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(19)
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    Number(_vm.form.irobot_usage_status) === 4
                      ? _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.irobot_usage_status_other,
                                expression: "form.irobot_usage_status_other"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "form-alert": _vm.errors.has(
                                "irobot.irobot_usage_status_other"
                              )
                            },
                            style: _vm.$mq.phone ? "" : "width:40%",
                            attrs: {
                              type: "text",
                              id: "irobot_usage_status_other",
                              name: "irobot_usage_status_other"
                            },
                            domProps: {
                              value: _vm.form.irobot_usage_status_other
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form,
                                  "irobot_usage_status_other",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.has("irobot.irobot_usage_status")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.has("irobot.irobot_usage_status_other")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(20),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pl-2" }, [
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.gender,
                                expression: "form.gender"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "gender",
                              id: "man",
                              value: "เพศชาย"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.gender, "เพศชาย")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "gender", "เพศชาย")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(21)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.gender,
                                expression: "form.gender"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "gender",
                              id: "women",
                              value: "เพศหญิง"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.gender, "เพศหญิง")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "gender", "เพศหญิง")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(22)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.gender,
                                expression: "form.gender"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "gender",
                              id: "other",
                              value: "other"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.gender, "other")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "gender", "other")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(23)
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("irobot.gender")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(24),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pl-2" }, [
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.age,
                                expression: "form.age"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "age",
                              id: "age_20_30",
                              value: "20-30"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.age, "20-30")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "age", "20-30")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(25)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.age,
                                expression: "form.age"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "age",
                              id: "age_31_40",
                              value: "31-40"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.age, "31-40")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "age", "31-40")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(26)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.age,
                                expression: "form.age"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "age",
                              id: "age_41_50",
                              value: "41-50"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.age, "41-50")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "age", "41-50")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(27)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.age,
                                expression: "form.age"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "age",
                              id: "age_51_60",
                              value: "51-60"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.age, "51-60")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "age", "51-60")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(28)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.age,
                                expression: "form.age"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "age",
                              id: "age_61",
                              value: "61"
                            },
                            domProps: { checked: _vm._q(_vm.form.age, "61") },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "age", "61")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(29)
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("irobot.age")
                      ? _c(
                          "div",
                          { staticClass: "mt-1 text-remark -status-alert" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.required_field")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "salary" } }, [
                      _vm._v("รายได้เฉลี่ยต่อเดือน (Average monthly income)")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pl-2" }, [
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.salary,
                                expression: "form.salary"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "salary",
                              id: "s_15_20",
                              value: "15000-20000"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.salary, "15000-20000")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "salary",
                                  "15000-20000"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(30)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.salary,
                                expression: "form.salary"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "salary",
                              id: "s_20_30",
                              value: "20001-30000"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.salary, "20001-30000")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "salary",
                                  "20001-30000"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(31)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.salary,
                                expression: "form.salary"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "salary",
                              id: "s_30_40",
                              value: "30001-40000"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.salary, "30001-40000")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "salary",
                                  "30001-40000"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(32)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.salary,
                                expression: "form.salary"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "salary",
                              id: "s_40_50",
                              value: "40001-50000"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.salary, "40001-50000")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "salary",
                                  "40001-50000"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(33)
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp col-12" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.salary,
                                expression: "form.salary"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "salary",
                              id: "s_50",
                              value: "50001"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.salary, "50001")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "salary", "50001")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(34)
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(35),
                  _vm._v(" "),
                  _vm._m(36)
                ]
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mt-4" }, [
      _c("h2", [_vm._v("ขอบคุณที่ลงทะเบียน")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "BeNeat ขอขอบคุณท่านที่ให้ความสนใจเข้าร่วมโครงการ จะมีทางเจ้าหน้าที่ติดต่อท่านเพื่อยืนยันการเข้าร่วมกิจกรรมล่วงหน้า 1 วัน"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("แบบฟอร์มลงทะเบียนเข้าร่วมกิจกรรม Workshop"),
      _c("br"),
      _vm._v("BeNeat x iRobot"),
      _c("br"),
      _vm._v("(สะอาด x 2 เพื่อบ้านสะอาดที่สุด)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("แบบฟอร์มลงทะเบียนเข้าร่วมกิจกรรม Workshop"),
      _c("br"),
      _vm._v("BeNeat x iRobot"),
      _c("br"),
      _vm._v("(สะอาด x 2 เพื่อบ้านสะอาดที่สุด)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v("ชื่อ-นามสกุล")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v("หมายเลขโทรศัพท์")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "workshop_date" } }, [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v("วันที่ต้องการเข้าร่วม")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "workshop_date_1" } },
      [
        _c("span"),
        _vm._v(
          "\n                                19 ตุลาคม 2567\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "workshop_date_2" } },
      [
        _c("span"),
        _vm._v(
          "\n                                20 ตุลาคม 2567\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "workshop_time" } }, [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v("รอบที่ต้องการเข้าร่วม")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "workshop_time_1" } },
      [
        _c("span"),
        _vm._v(
          "\n                                ช่วงเข้า 10:30 - 12:00 น.\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "workshop_time_2" } },
      [
        _c("span"),
        _vm._v(
          "\n                                ช่วงบ่าย 14:00 - 15:30 น.\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "number_of_paticipants" } }, [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v(
        "ที่นั่งในแต่ละรอบมีจำนวนจำกัด โปรดระบุจำนวนผู้เข้าร่วม (รวมตัวท่าน)"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "number_of_paticipants_1" } },
      [
        _c("span"),
        _vm._v(
          "\n                                1 ท่าน\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "number_of_paticipants_2" } },
      [
        _c("span"),
        _vm._v(
          "\n                                2 ท่าน\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "number_of_paticipants_3" } },
      [
        _c("span"),
        _vm._v(
          "\n                                3 ท่าน\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "irobot_usage_status" } }, [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v(
        "ที่นั่งในแต่ละรอบมีจำนวนจำกัด โปรดระบุจำนวนผู้เข้าร่วม (รวมตัวท่าน)"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "irobot_usage_status_1" } },
      [
        _c("span"),
        _vm._v(
          "\n                                ปัจจุบันใช้ iRobot\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "irobot_usage_status_2" } },
      [
        _c("span"),
        _vm._v(
          "\n                                ไม่เคยใช้ iRobot\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "irobot_usage_status_3" } },
      [
        _c("span"),
        _vm._v(
          "\n                                เคยทดลองใช้ iRobot แต่ไม่ได้ใช้แล้ว\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "irobot_usage_status_4" } },
      [
        _c("span"),
        _vm._v(
          "\n                                อื่น ๆ โปรดระบุ…\n                              "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "gender" } }, [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v("เพศ (Gender)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "man" } }, [
      _c("span"),
      _vm._v(
        "\n                                เพศชาย (Male)\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "women" } }, [
      _c("span"),
      _vm._v(
        "\n                                เพศหญิง (Female)\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "other" } }, [
      _c("span"),
      _vm._v(
        "\n                                ไม่ระบุ (Other)\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "text-danger mr-1" }, [_vm._v("*")]),
      _vm._v("อายุ (Age)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_20_30" } }, [
      _c("span"),
      _vm._v(
        "\n                                20 - 30 ปี\n                                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_31_40" } }, [
      _c("span"),
      _vm._v(
        "\n                                31 - 40 ปี\n                                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_41_50" } }, [
      _c("span"),
      _vm._v(
        "\n                                41 - 50 ปี\n                                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_51_60" } }, [
      _c("span"),
      _vm._v(
        "\n                                51 - 60 ปี\n                                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_61" } }, [
      _c("span"),
      _vm._v(
        "\n                                มากกว่า 61 ปี\n                                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_15_20" } }, [
      _c("span"),
      _vm._v(
        "\n                                15,000 - 20,000 บาท\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_20_30" } }, [
      _c("span"),
      _vm._v(
        "\n                                20,001 - 30,000 บาท\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_30_40" } }, [
      _c("span"),
      _vm._v(
        "\n                                30,001 - 40,000 บาท\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_40_50" } }, [
      _c("span"),
      _vm._v(
        "\n                                40,001 - 50,000 บาท\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_50" } }, [
      _c("span"),
      _vm._v(
        "\n                                มากกว่า 50,000 บาท\n                              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "text-danger" }, [
        _vm._v(
          "* จะมีทางเจ้าหน้าที่ติดต่อท่าน เพื่อยืนยันการเข้าร่วมกิจกรรมล่วงหน้า 1 วันนะคะ"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center pb-5 mt-2" }, [
      _c(
        "button",
        {
          staticClass: "btn btn__submit btn-lg px-5 mt-3",
          attrs: { type: "submit" }
        },
        [_vm._v("\n                        Submit\n                    ")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6503ade0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6503ade0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey/IRobotSurvey.vue
// module id = 2362
// module chunks = 0